import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromGroupSharing from './reducers/group-sharing.reducer';
import { GroupSharingEffects } from './effects/group-sharing.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('GroupSharing', fromGroupSharing.reducer),
    EffectsModule.forFeature([GroupSharingEffects])
  ]
})
export class GroupSharingModule { }
